import { render, staticRenderFns } from "./PendingApplicationData.vue?vue&type=template&id=75b20dfe"
import script from "./PendingApplicationData.vue?vue&type=script&lang=js"
export * from "./PendingApplicationData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports